import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
const AllocateTaskAdd = () => {
  const initialFormData = {
    ProjectID: null,
    StartDate: moment(new Date()).format("DD-MMM-YYYY"),
    EndDate: "",
    Name: "",
    Details: "",
    CategoryID: null,
    Status: null,
    AssignedTo: null,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("Allocate Task"));
    fetchIndexData();
  }, [dispatch]);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [newStatusOptions, setNewStatusOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [isSuperAdminFlag, setIsSuperAdminFlag] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (formData?.ProjectID) {
      fetchEmpListData(formData?.ProjectID);
    }
  }, [formData?.ProjectID]);
  useEffect(() => {
    if (formData?.AssignedTo) {
      fetchProjectNameData(formData?.AssignedTo);
    }
  }, [formData?.AssignedTo]);

  const fetchIndexData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/task-allocation?P_EmployeeID=&P_ProjectID=`
      );

      if (response.status === 200) {
        setPageLoading(false);
        const cleanedData = response?.data?.data;
        setIsSuperAdminFlag(cleanedData?.isSuperAdmin);

        if (cleanedData?.isSuperAdmin == 0) {
          const empOpt = cleanedData?.employeeList.map((employee) => ({
            value: employee.value,
            label: employee.text,
            // Add other properties if needed
          }));
          setEmployeeOptions(empOpt); // Remove the extra array wrapper []
        } else {
          const projectOpt = cleanedData?.prj?.map((o) => ({
            value: o.value,
            label: o.text,
          }));
          setProjectOptions(projectOpt);
        }

        const statusOpt = cleanedData?.newStatus?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setStatusOptions(statusOpt);
        setFormData((prevData) => ({
          ...prevData,
          Status: statusOpt[0].value,
        }));

        setLoading(false);
      } else {
        console.error("Failed to fetch tasks:", response.status);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setLoading(false);
    }
  };

  const fetchProjectNameData = async (empID) => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/task-allocation/getProjectName?EmployeeID=${empID}`
      );

      if (response.status === 200) {
        const prjOpt = response?.data?.data?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setProjectOptions(prjOpt);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchEmpListData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/task-allocation/getEmployeeName?ProjectID=${id}`
      );

      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        const empOpt = cleanedData?.data?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setEmployeeOptions(empOpt);

        setLoading(false);
      } else {
        console.error("Failed to fetch tasks:", response.status);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setLoading(false);
    }
  };
  const validationSchema = Yup.object().shape({
    ProjectID: Yup.number()
      .typeError("Project is required")
      .required("Project is required"),
    AssignedTo: Yup.number()
      .typeError("Assigned To is required")
      .required("Assigned To is required"),
    Name: Yup.string().required("Task name is required"),
    StartDate: Yup.string().required("From Date Required"),
    EndDate: Yup.string().nullable(),
    Details: Yup.string().nullable(),
    CategoryID: Yup.number().nullable(),
    Status: Yup.number()
      .typeError("Status is required")
      .required("Status is required"),
  });

  const validateField = async (fieldName, value) => {
    try {
      await validationSchema.validateAt(fieldName, { [fieldName]: value });
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
      return true;
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
      return false;
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    await validateField(name, value);
  };

  const handleSelect = async (selectedOption, name) => {
    const value = selectedOption ? selectedOption.value : null;
    setFormData((prev) => ({ ...prev, [name]: value }));
    await validateField(name, value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate entire form
      await validationSchema.validate(formData, { abortEarly: false });

      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/task/task-allocation`,
        formData,
        "post"
      );

      if (response?.status === 200) {
        toast.success("Task created successfully!");
        setTimeout(() => {
          navigate("/allocate-task");
        }, 1000);
      } else {
        throw new Error(response?.data?.message || "Failed to create task");
      }
    } catch (error) {
      console.error("Error creating task:", error);

      if (error.inner) {
        // Yup validation errors
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
      } else {
        toast.error(error.message || "Error creating task");
      }
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="Container">
        <form
          // onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-2 bg-white"
        >
          <div className="p-3">
            <div className="row">
              {isSuperAdminFlag === 1 ? (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Project<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ProjectID"
                    options={projectOptions}
                    onChange={(option, action) =>
                      handleSelect(option, action.name)
                    }
                    value={projectOptions.find(
                      (o) => o.value === formData.ProjectID
                    )}
                    className={errors.ProjectID ? "is-invalid" : ""}
                  />
                  {errors.ProjectID && (
                    <div className="invalid-feedback d-block">
                      {errors.ProjectID}
                    </div>
                  )}
                </div>
              ) : (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Allocate To<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="AssignedTo"
                    options={employeeOptions}
                    onChange={(option, action) =>
                      handleSelect(option, action.name)
                    }
                    value={employeeOptions.find(
                      (o) => o.value === formData.AssignedTo
                    )}
                    // className={errors.AssignedTo ? "is-invalid" : ""}
                    styles={{
                      margin:"0px",
                      control: (base) => ({
                        ...base,
                        borderColor: errors.AssignedTo
                          ? "#dc3545"
                          : base.borderColor,
                      }),
                    }}
                  />{" "}
                  {errors.AssignedTo && (
                    <div className="invalid-feedback d-block">
                      {errors.AssignedTo}
                    </div>
                  )}
                </div>
              )}

              <div className="col-md-3 mb-3">
                <label className="form-label">Category</label>
                <Select
                  name="CategoryID"
                  options={categoryOptions}
                  onChange={(option, action) =>
                    handleSelect(option, action.name)
                  }
                  value={categoryOptions.find(
                    (o) => o.value === formData.CategoryID
                  )}
                />
              </div>
              {isSuperAdminFlag === 1 ? (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Allocate To<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="AssignedTo"
                    options={employeeOptions}
                    onChange={(option, action) =>
                      handleSelect(option, action.name)
                    }
                    value={employeeOptions.find(
                      (o) => o.value === formData.AssignedTo
                    )}
                  />{" "}
                  {errors.AssignedTo && (
                    <div className="invalid-feedback d-block">
                      {errors.AssignedTo}
                    </div>
                  )}
                </div>
              ) : (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    Project<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="ProjectID"
                    options={projectOptions}
                    onChange={(option, action) =>
                      handleSelect(option, action.name)
                    }
                    value={projectOptions.find(
                      (o) => o.value === formData.ProjectID
                    )}
                    // className={errors.ProjectID ? "is-invalid" : ""}
                            styles={{
                      margin:"0px",
                      control: (base) => ({
                        ...base,
                        borderColor: errors.ProjectID
                          ? "#dc3545"
                          : base.borderColor,
                      }),
                    }}
                  />
                  {errors.ProjectID && (
                    <div className="invalid-feedback d-block">
                      {errors.ProjectID}
                    </div>
                  )}
                </div>
              )}

              <div className="col-md-3 mb-3">
                <label className="form-label">
                  Task<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="Name"
                  className={`form-control mb-0 ${errors.Name ? "is-invalid" : ""}`}
                  value={formData.Name}
                  onChange={handleChange}
                />
                {errors.Name && (
                  <div className="invalid-feedback d-block">{errors.Name}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  Status<span className="text-danger">*</span>
                </label>
                <Select
                  name="Status"
                  options={statusOptions}
                  onChange={(option, action) =>
                    handleSelect(option, action.name)
                  }
                  value={statusOptions.find((o) => o.value === formData.Status)}
                />{" "}
                {errors.Status && (
                  <div className="invalid-feedback d-block">
                    {errors.Status}
                  </div>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label">
                  From Date<span className="text-danger">*</span>
                </label>
                <CustomDatePicker
                  name="StartDate"
                  value={
                    formData.StartDate
                      ? moment(formData.StartDate).format("DD-MMM-YYYY")
                      : null
                  }
                  handleChange={handleChange}
                />{" "}
                {errors.StartDate && (
                  <div className="invalid-feedback d-block">
                    {errors.StartDate}
                  </div>
                )}
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label">To Date</label>
                <CustomDatePicker
                  name="EndDate"
                  value={
                    formData.EndDate
                      ? moment(formData.EndDate).format("DD-MMM-YYYY")
                      : null
                  }
                  handleChange={handleChange}
                  minDate={new Date(formData.StartDate)}
                />{" "}
                {errors.EndDate && (
                  <div className="invalid-feedback d-block">
                    {errors.EndDate}
                  </div>
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  name="Details"
                  className="form-control"
                  value={formData.Details}
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="d-flex justify-content-end align-items-end m-2  text-right me-2">
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => navigate("/allocate-task")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="custom-btn"
                    disabled={loading ? true : false}
                  >
                    {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

export default AllocateTaskAdd;
